type Level = 'info' | 'warn' | 'error';

/**
 * Logger con scope. Usar `log('error', 'facturacion', 'falló emisión', { id })`.
 * El `ctx` acepta cualquier objeto o primitivo — típicamente filtros o detalles.
 * En producción se puede conectar a un sink externo sin cambiar los call sites.
 */
export function log(level: Level, scope: string, msg: string, ctx?: unknown): void {
  const line = `[${scope}] ${msg}`;
  if (level === 'error') {
    console.error(line, ctx ?? '');
  } else if (level === 'warn') {
    console.warn(line, ctx ?? '');
  } else {
    console.log(line, ctx ?? '');
  }
}
